<template>
	<div class="nav-wrapper">
		<div class="item-nav-wrapper">
			<div class="logo-wrapper">
				<img class="logo" alt="getREEF Logo" :src="logo" />
			</div>
			<nav class="item-nav">
				<button
					class="btn btn-back"
					@click="goBack"
					:disabled="!backButton"
					:style="{ opacity: backButton ? 1 : 0 }"
				>
					<i class="sk-icon-chevron-left"></i>
					<div class="menuText">Menu</div>
					<div class="backToMenuText">Back to Menu</div>
				</button>
				<button
					class="btn support-btn"
					@click="supportClicked"
					:disabled="!supportButton"
					:style="{ opacity: supportButton ? 1 : 0 }"
				>
					SUPPORT
				</button>
			</nav>
		</div>
	</div>
</template>

<script>
import { eventBus, EventBusEvents } from "@/eventBus"

export default {
	name: "Navbar",
	props: {
		supportButton: {
			type: Boolean,
			default: true
		},
		backButton: {
			type: Boolean,
			default: true
		},
		logoSrc: String
	},
	computed: {
		logo() {
			return this.logoSrc ? this.logoSrc : this.$logoLightSrc
		}
	},
	methods: {
		goBack: function () {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Go Back Clicked"
			})
			if (this.$route.query && this.$route.query.step) {
				switch (this.$route.query.step) {
					case "contact":
						this.$router.push({ query: {} })
						break
					case "creditcard":
						this.$router.push({ query: { step: "contact" } })
						break
				}
			} else if (this.$route.query && this.$route.query.editing) {
				this.$router.push({
					path: `/${this.$route.params.slug}/checkout`
				})
			} else {
				let menuPath = `/${this.$route.params.slug}/menu`
				if (this.$route.meta.preview) {
					menuPath = `${menuPath}/preview`
				}
				if (this.$route.params.preview_menu) {
					menuPath = `${menuPath}/${this.$route.params.preview_menu}`
				}
				this.$router.push({ path: menuPath })
			}
		},
		supportClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Support Clicked"
			})
			eventBus.emit(EventBusEvents.OPEN_SUPPORT_MODAL)
		}
	}
}
</script>

<style scoped>
.item-nav-wrapper {
	background: transparent;
	position: absolute;
	top: 0;
	width: 100%;
	left: 0;
	z-index: 1;
	height: 40px;
}

.modal-open .item-nav-wrapper {
	z-index: 0;
}

.item-nav {
	width: 99%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px;
	position: absolute;
	inset: 0;
}

@media only screen and (max-width: 900px) {
	.item-nav {
		width: 100%;
	}
}

@media only screen and (max-width: 1200px) {
	.item-nav {
		width: 97.25%;
	}
}

.logo-wrapper {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	height: 28px;
	display: flex;
	justify-content: center;
	margin: auto;
}

.logo {
	width: 177px;
}

.sk-icon-chevron-left {
	margin-right: 10px;
	color: var(--gR-black);
}

.btn-back {
	background: none;
}

@media (max-width: 700px) {
	.backToMenuText {
		display: none;
	}
}

@media (min-width: 700px) {
	.menuText {
		display: none;
	}
}

@media (max-width: 700px) {
	.logo {
		width: 126px;
	}

	.logo-wrapper {
		height: 20px;
	}
}
</style>